import { createWireDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: createWireDepositSlice, asyncAction: createWireDepositAction } = createAsyncSlice(
  'createWireDepositSlice',
  createWireDepositAsync
);
